var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgBarcode = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 20,
  height: 20,
  fill: "none",
  viewBox: "0 0 20 20"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  d: "M2.125 3a.875.875 0 0 0-.875.875v12.25a.875.875 0 1 0 1.75 0V3.875A.875.875 0 0 0 2.125 3M12.21 3a.875.875 0 0 0-.875.875v12.25a.875.875 0 1 0 1.75 0V3.875A.875.875 0 0 0 12.21 3m-7.045.875c0-.483.392-.875.875-.875h1.75c.484 0 .875.392.875.875v12.25A.875.875 0 0 1 7.79 17H6.04a.875.875 0 0 1-.875-.875zM16.125 3a.875.875 0 0 0-.875.875v12.25c0 .483.392.875.875.875h1.75a.875.875 0 0 0 .875-.875V3.875A.875.875 0 0 0 17.875 3z"
})));
SvgBarcode.displayName = "SvgBarcode";
export { SvgBarcode as ReactComponent };
export default SvgBarcode;